import { message } from 'antd';

import { ROUTE_CONSTANTS } from '@/routes';

export function showMessage(type: 'success' | 'error', content: string) {
  void message.open({ type, content, duration: 5 });
}

export function logger(message: string, level = 'info') {
  switch (level) {
    case 'info':
      console.info(message);
      break;
    case 'warn':
      console.warn(message);
      break;
    case 'error':
      console.error(message);
      break;
    default:
      console.log(message);
      break;
  }
}

export function checkRoutePath(pathname: string) {
  const paths = [
    ROUTE_CONSTANTS.HOME_PATH,
    ROUTE_CONSTANTS.APPS_PATH,
    ROUTE_CONSTANTS.DOCUMENT_PATH,
    ROUTE_CONSTANTS.CONTACTS_PATH,
  ];

  return paths.find((path) => pathname === path) || '';
}

export function getImageUrl(imagePath: string) {
  const baseUrl = process.env.NODE_ENV === 'development' ? '/api' : '';
  return `${baseUrl}${imagePath}`;
}

export function humanFileSize(bytes: number) {
  const thresh = 1024;
  if (bytes < thresh) return bytes + ' B';
  const units = ['KB', 'MB', 'GB', 'TB'];
  let u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (bytes >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + ' ' + units[u];
}

export function toGermanDate(date: string) {
  return new Date(date).toLocaleDateString('de-DE', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
